var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form-editor',{attrs:{"isReadonly":true,"isAutosave":true,"surveyStructure":_vm.structure,"save":_vm.saveMethod,"type":_vm.formType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }